import React from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames/bind';
import styles from './index.less';

const cx = classNames.bind(styles);

const SharedStatusIcon = ({ intl }) => {
  const { formatMessage } = intl;
  return (
    <div className={cx('panel-title-shared')}>
      <span>{formatMessage({ id: 'page.SharedStatusIcon.shared' })}</span>
    </div>
  );
};

export default injectIntl(SharedStatusIcon);



// WEBPACK FOOTER //
// ./src/components/ui/SharedStatusIcon/index.jsx